import { DocumentFile } from '../../api/app-types/document.app';

export function downloadDocumentFile(file: Pick<DocumentFile, 'location' | 'name'>) {
	if (!file.location.startsWith('https://')) return;
	const link = document.createElement('a');
	link.href = file.location;
	link.download = file.name;
	link.target = '_blank';
	link.click();
}

export function downloadDocumentFiles(files: Pick<DocumentFile, 'location' | 'name'>[]) {
	files.forEach(downloadDocumentFile);
}
